<template>
  <div class="page-wrapper">
    <LoadingPlugin
      :active.sync="isLoading"
      :is-full-page="true"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    ></LoadingPlugin>

    <ConfirmModal
      :msg="
        alarm.settings.snooze ? $t('confirm_unsnooze') : $t('confirm_snooze')
      "
      :show="showConfirm"
      :heading="alarm.settings.snooze ? $t('unsnooze') : $t('snooze_alarm')"
      :btnTxt="
        alarm.settings.snooze ? $t('btn_text_unsnooze') : $t('btn_text_snooze')
      "
      @close="showConfirm = false"
      @submit="handleSnooze"
    />

    <DeleteModal
      :show="showDeleteAlarm"
      @close="showDeleteAlarm = false"
      :name="$t('alarm')"
      @submit="doDeleteAlarm"
    />

    <SuccessModal
      :show="showSuccessPopup"
      @close="handleCloseSuccessModal"
      :msg="successMsg.msg"
      :heading="successMsg.heading"
    />

    <div class="page-breadcrumb">
      <div class="row">
        <div class="col-md-12 col-lg-12 align-self-center">
          <ul class="breadcrumb mb-2 list-style-none">
            <li
              class="breadcrumb-item h6 font-16 mylink"
              style="margin-right: 3rem"
            >
              <router-link class="mylink" to="details">{{
                $t("details")
              }}</router-link>
            </li>
            <li
              class="breadcrumb-item h6 font-16 mylink"
              v-show="profile.role !== 'staff'"
              style="margin-right: 3rem"
              v-if="canPerformAction('alarms', 'edit')"
            >
              <router-link class="mylink" to="settings">{{
                $t("settings")
              }}</router-link>
            </li>

            <div
              class="ml-auto d-flex"
              v-if="canPerformAction('alarms', 'edit')"
            >
              <button
                class="btn d-block mr-3"
                :class="'btn-outline-danger'"
                @click="openDeleteAlarm"
                v-if="this.$route.name == 'AlarmSettings'"
              >
                {{ $t("delete_alarm") }}
              </button>

              <button
                @click="showConfirm = true"
                class="btn btn-secondary ml-auto"
              >
                {{
                  alarm.settings.snooze ? $t("unsnooze") : $t("snooze_alarm")
                }}
              </button>
            </div>
          </ul>
        </div>
      </div>
    </div>

    <div class="page p-4">
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ConfirmModal from "../Modals/ConfirmModal.vue";
import SuccessModal from "../Modals/SuccessModal.vue";
import LoadingPlugin from "vue-loading-overlay";
import DeleteModal from "../Modals/DeleteModal.vue";

export default {
  name: "ViewAlarm",
  computed: {
    ...mapGetters([
      "alarm",
      "profile",
      "devices",
      "users",
      "geofence",
      "canPerformAction",
    ]),
    successMsg() {
      let key = this.action;
      switch (key) {
        case "snooze":
          return {
            msg: this.$t("success_msg_alarm"),
            heading: this.$t("success_heading_alarm"),
          };
        case "unsnooze":
          return {
            msg: this.$t("success_msg_alarm_unsnooze"),
            heading: this.$t("success_heading_alarm_unsnooze"),
          };
        case "delete":
          return {
            msg: this.$t("success_msg_alarm_delete"),
            heading: this.$t("success_heading_alarm_delete"),
          };
        default:
          return "";
      }
    },
  },
  components: { ConfirmModal, SuccessModal, LoadingPlugin, DeleteModal },
  data() {
    return {
      showConfirm: false,
      showSuccessPopup: false,
      showDeleteAlarm: false,
      isLoading: true,
      action: "",
    };
  },
  methods: {
    ...mapActions([
      "snoozeAlarm",
      "getAlarmById",
      "getAlarmById",
      "deleteAlarm",
    ]),

    handleSnooze() {
      this.isLoading = true;
      const data = {
        snooze: this.alarm?.settings?.snooze ? false : true,
      };
      this.snoozeAlarm({ id: this.$route.params.alarmId, data })
        .then((res) => {
          this.getAlarmById(this.$route.params.alarmId).then(() => {
            this.isLoading = false;
          });
          this.action = this.alarm?.settings?.snooze ? "unsnooze" : "snooze";
          this.showSuccessPopup = true;
          this.showConfirm = false;
        })
        .catch((error) => {
          this.isLoading = false;
          // error.response can be null
          // bus.$emit("deleted", this.Errormssg);
          if (error.response) {
            //console.log(error.response.data.message);
          }
        });
    },
    openDeleteAlarm() {
      this.showDeleteAlarm = true;
    },
    doDeleteAlarm() {
      this.isLoading = true;
      this.deleteAlarm(this.$route.params.alarmId)
        .then((res) => {
          // this.mssg =
          //   res.data.message[0].toUpperCase() + res.data.message.slice(1);
          this.action = "delete";
          this.showSuccessPopup = true;
          this.showDeleteAlarm = false;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          this.Errormssg =
            error.response.data.message[0].toUpperCase() +
            error.response.data.message.slice(1);
          // error.response can be null
          if (error.response) {
            //console.log(error.response.data.message);
          }
        });
    },
    handleCloseSuccessModal() {
      if (this.action === "delete") {
        this.$router.push(`/alarms`);
      } else {
        this.showSuccessPopup = false;
        this.action = "";
      }
    },
  },
  mounted() {
    this.getAlarmById(this.$route.params.alarmId).then(() => {
      this.isLoading = false;
    });
  },
};
</script>

<style>
.mylink {
  color: #213e7a !important;
  font-size: 14px !important;
  text-decoration-color: #213e7a !important;
}
.mylink :hover {
  color: #213e7a !important;
  text-decoration: underline;
  text-underline-offset: 5px;
  text-decoration-color: #213e7a !important;
}
.router-link-exact-active.router-link-active {
  text-decoration: underline !important;
  color: #213e7a !important;
  cursor: default;
  text-underline-offset: 5px;
}
</style>
